import * as api from '../../api/carga-emision-pagos-cia-client';
import { 
    GET_CARGAS_PREVIAS,
    POST_CARGAR_ARCHIVO,
    GET_INGRESO_PAGOS
} from '../types';


export const cargasPreviasAction = (query) => ({
    type: GET_CARGAS_PREVIAS,
    payload: api.getCargasPrevias(query)
});
export const obtenerIngresoPagosExcel = (query) => ({
    type: GET_INGRESO_PAGOS,
    payload: api.getIngresoPagos(query)
});

export const cargarArchivoAction = (file) => ({
    type: POST_CARGAR_ARCHIVO,
    payload: api.postCargarArchivo(file)
})